import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/Service/Common.service';
import { MapRoleFeatureService } from 'src/app/Service/map-role-feature/map-role-feature.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { PeerReviewService } from 'src/app/Service/peerReview/peer-review.service';
import { ReviewViewComponent } from "../review-view/review-view.component";
import { MatDialog } from '@angular/material/dialog';
import { DocDetailsOutput } from 'src/app/ViewModel/PeerReviewModel';


@Component({
  selector: 'app-review-comments',
  templateUrl: './review-comments.component.html',
  styleUrls: ['./review-comments.component.css']
})
export class ReviewCommentsComponent implements OnInit {
  approve : number = 0;
  invite : number = 0;
  memberId: number = 0;
  status : number = 0;
  comment : number = 0;
  response : number = 0;
  impact : number = 0;
  total : number = 0;
  selectedTab: boolean = true;
  public mainList: any[] = [];
  public reviewList: any[] = [];
  public commentaction: boolean = false;
  Feature: any[]=[];
  project_Id !: number;
  groupId !: number;
  public enableFilter : boolean = false;

  constructor(private ListService: PeerReviewService, private dialog: MatDialog, public notificationService: NotificationService,
    private mapRoleFeatureService: MapRoleFeatureService, private commonService: CommonService) { }

  ngOnInit() {
    this.project_Id = this.commonService.getProjectId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.memberId = this.commonService.getLoggedInUserId();
    this.getList();

    this.commonService.getProjectMemberFeatures(this.project_Id, this.memberId, this.groupId).subscribe((res: any[]) => {
      this.Feature = res;
      this.commentaction = this.Feature.some(x => x.feature_Desc == "PR Comments" && x.feature_Id==600005);
    });

  }

  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }

  getList(){
    let obj = {'Project_Id': this.commonService.getProjectId()}
    this.ListService.getReviewStatus(obj).subscribe(data => {
      this.mainList = data;
    })
  }
  
  viewDocumentClick(dataItem:any) {
    this.selectedTab = false;
    this.reviewList = dataItem;
  }

  closeViewTab() {
    this.selectedTab = true;
    this.reviewList = [];
  }

  viewPeerdoc(dataItem: any) {
    let datainput =
    {
      strDocNumber: dataItem.requestNo,
      intUID: this.memberId
    };

    this.ListService.getPeerDocView(datainput).subscribe((resDoc: DocDetailsOutput) => {
      if (resDoc) {
        let dialogRef = this.dialog.open(ReviewViewComponent,
          {
            panelClass: 'mat-dialog-primary',
            data: { docvalue: resDoc, input: datainput }
          });
        dialogRef.afterClosed().subscribe(() => {
        });
      }
    }, err => { });
  }


}
